import axios from "axios";

export default {
  async findAll() {
    return axios.get(`/users`);
  },
  async delete({ id }) {
    return axios.delete(`/users/${id}`);
  },
  async update({ id, isActive }) {
    return axios.patch(`/users/${id}`, { isActive });
  }
};
